import { Card, CardContent } from "@/components/ui/card";
import { Package, Clock, CheckCircle, ExternalLink } from "lucide-react";

export default function PrescriptionOverview({ prescriptions }) {
  // Count medications by dispense status
  const pendingMedications = prescriptions
    .filter((p) => p.dispenseStatus === "pending")
    .reduce((sum, p) => sum + (p.medications?.length || 0), 0);

  const partiallyDispensedMedications = prescriptions
    .filter((p) => p.dispenseStatus === "partially_dispensed")
    .reduce((sum, p) => sum + (p.medications?.length || 0), 0);

  const fullyDispensedMedications = prescriptions
    .filter((p) => p.dispenseStatus === "fully_dispensed")
    .reduce((sum, p) => sum + (p.medications?.length || 0), 0);

  const externalMedications = prescriptions
    .filter((p) => p.dispenseStatus === "external")
    .reduce((sum, p) => sum + (p.medications?.length || 0), 0);

  const StatCard = ({ title, value, icon: Icon, color, description }) => (
    <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-lg hover:shadow-xl transition-all duration-300">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <p className="text-sm font-medium text-slate-600">{title}</p>
            <p className="text-3xl font-bold text-slate-900">{value}</p>
            {description && (
              <p className="text-sm text-slate-500">{description}</p>
            )}
          </div>
          <div
            className={`p-3 rounded-xl bg-gradient-to-br ${color} shadow-lg`}
          >
            <Icon className="w-6 h-6 text-white" />
          </div>
        </div>
      </CardContent>
    </Card>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <StatCard
        title="Pending"
        value={pendingMedications}
        icon={Clock}
        color="from-yellow-500 to-yellow-600"
        description="Awaiting dispensing"
      />
      <StatCard
        title="Partially Dispensed"
        value={partiallyDispensedMedications}
        icon={Package}
        color="from-blue-500 to-blue-600"
        description="In progress"
      />
      <StatCard
        title="Fully Dispensed"
        value={fullyDispensedMedications}
        icon={CheckCircle}
        color="from-green-500 to-green-600"
        description="Completed"
      />
      <StatCard
        title="External"
        value={externalMedications}
        icon={ExternalLink}
        color="from-purple-500 to-purple-600"
        description="External pharmacy"
      />
    </div>
  );
}
